<template>
    <layout-basic>
        <v-container fluid>
            <v-row>
                <v-col md="12">
                    <v-card flat>
                        <v-card-actions>
                            <v-text-field
                            class="ml-5"
                            placeholder="Search Partners"
                            prepend-icon="fa-search"
                            v-model="search"
                            type="text"
                            clearable
                            clear-icon="fa-times"
                            @click:clear="resetSearch"
                            @change="applySearch"
                            ></v-text-field>
                            <v-spacer></v-spacer>
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
            <v-row>
                <v-col md="12">
                    <v-card flat>
                        <v-card-title>
                            <div class="flex-grow-1"></div>
                        </v-card-title>
                        <v-data-table
                        :headers="headers"
                        :options.sync="options"
                        :server-items-length="serverItemsLength"
                        :loading="loading"
                        :items="users"
                        >
                            <template v-slot:item.confirmed="{ item }">
                                <v-icon v-if="item.confirmed" color="primary">fa-check</v-icon>
                                <v-icon v-else color="error">fa-times</v-icon>
                            </template>
                            <template v-slot:item.id="{ item }">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn
                                        :id="item.id"
                                        :to="'/partner/reports/' + item.user_id"
                                        outlined
                                        small
                                        color="secondary"
                                        >
                                            <v-icon small>fa-eye</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>View Detailed Report</span>
                                </v-tooltip>
                            </template>
                        </v-data-table>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </layout-basic>
</template>

<script>
    import userAPI from "@/api/partner.js";
    import LayoutBasic from "@/layouts/PartnerHub";
    export default {
        name: "UsersReport",
        components: {
            LayoutBasic
        },
        data() {
            return {
                headers: [
                    { text: "Company", value: "company_name" },
                    { text: "First Name", value: "users.data.first_name" },
                    { text: "Surname", value: "users.data.last_name" },
                    { text: "Email", value: "users.data.email" },
                    { text: "Last Login", value: "users.data.last_login", sortable: false },
                    { text: "Total Customers", value: "total_clients", sortable: false },
                    {
                        text: "",
                        value: "id",
                        sortable: false,
                        align: "end"
                    }
                ],
                users: [],
                search: "",
                searchParams: "",
                pagination: {},
                options: {},
                loading: false,
            };
        },
        computed: {
            serverItemsLength: function() {
                return this.pagination.total;
            },
            itemsPerPage: function() {
                return this.pagination.per_page;
            },
            page: function() {
                return this.pagination.current_page;
            },
            params: function() {
                return this.$gf.getQueryString(this.options, this.serverItemsLength);
            }
        },
        watch: {
            options: {
                handler() {
                    this.getCustomers();
                },
                deep: true
            }
        },
        methods: {
            getCustomers() {
                this.loading = true;
                userAPI.getPartners(this.params + '&include=users', this.searchParams).then(resp => {
                    this.users = resp.data.data;
                    this.pagination = resp.data.meta.pagination;
                    this.loading = false;
                });
            },
            resetSearch() {
              this.searchParams = "";
              this.getCustomers();
            },
            applySearch() {
              this.searchParams = this.params + "&search=first_name:" + this.search + ";last_name:" + this.search;
              this.getCustomers();
            }
        }
    };
</script>
